<!-- Dashboard -->
<div class="menu-item">
  <a
    class="menu-link without-sub"
    routerLink="/dashboard"
    routerLinkActive="active">
    <span class="menu-icon">
      <app-keenicon name="color-swatch" class="fs-2"></app-keenicon>
    </span>
    <span class="menu-title" translate="DASHBOARD"></span>
  </a>
</div>

<!-- Layout builder -->
<div class="menu-item">
  <a
    class="menu-link without-sub"
    routerLink="/listings"
    routerLinkActive="active"
  >
    <span class="menu-icon">
      <app-keenicon name="switch" class="fs-2"></app-keenicon>
    </span>
    <span class="menu-title">Listings</span>
  </a>
</div>
<!-- Separator -->
<div class="menu-item">
  <div class="menu-content pt-8 pb-2">
    <span class="menu-section text-muted text-uppercase fs-8 ls-1">Crafted</span>
  </div>
</div>
